module.exports = __webpack_public_path__ + "img/sbgl.9bf4064e.png";